/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ExternalLink: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="external-link" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M283.3333333333333 170H170V1076.6666666666667C170 1107.8333333333333 181.1066666666667 1134.4666666666667 203.2633333333333 1156.7366666666667A109.14 109.14 0 0 0 283.3333333333333 1190H623.3333333333333V1076.6666666666667H283.3333333333333V283.3333333333335H1076.6666666666665V623.3333333333334H1190V283.3333333333335C1190 252.1666666666668 1178.8933333333332 225.5333333333333 1156.7366666666667 203.2633333333333A109.14 109.14 0 0 0 1076.6666666666665 170H283.3333333333333zM549.6666666666666 470.3333333333334L470.3333333333333 549.6666666666667L997.3333333333334 1076.6666666666667H793.3333333333333V1190H1190V793.3333333333334H1076.6666666666665V997.3333333333331L549.6666666666666 470.3333333333333z" : "M226.6666666666667 136H136V861.3333333333333C136 886.2666666666667 144.8853333333333 907.5733333333332 162.6106666666667 925.3893333333332A87.312 87.312 0 0 0 226.6666666666667 952H498.6666666666667V861.3333333333333H226.6666666666667V226.6666666666667H861.3333333333334V498.6666666666666H952V226.6666666666667C952 201.7333333333332 943.1146666666666 180.4266666666666 925.3893333333334 162.6106666666666A87.312 87.312 0 0 0 861.3333333333334 136H226.6666666666667zM439.7333333333334 376.2666666666667L376.2666666666667 439.7333333333334L797.8666666666668 861.3333333333333H634.6666666666667V952H952V634.6666666666666H861.3333333333334V797.8666666666666L439.7333333333334 376.2666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ExternalLink.displayName = `Blueprint5.Icon.ExternalLink`;
export default ExternalLink;
